import { default as about1l6Nzr5WQ7Meta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsP3toUyZZVnMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93sDq7PciCwCMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplesR9JXJ1OXnMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productse5YmKhonlxMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_938MdlQThONLMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewDSRivCybRgMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexExTgh979urMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93KL9xLR62HXMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexkru1t6V1mZMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93KRFOhEBHioMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexrrGefgZMYFMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionszS59NDv40JMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsQCyzQyZEnjMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviews50tjGKze5LMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93vd9pK4Fm3GMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as index6jkYAMHr53Meta } from "/tmp/build_2d8369a5/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmSgGg5TuYCrMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmrIckoUXfWbMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendar7Gnc0inVOaMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatwwIArMtJuQMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutM6P6ZygKgOMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feed95sIyNEIv7Meta } from "/tmp/build_2d8369a5/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersgMifS8oKDtMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93XH9Vgeir6FMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45edithbSCi6jJtkMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93gYqaybh5lrMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityeQAUNir0myMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93rwkJdlSeYHMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93nuY9TOaTa5Meta } from "/tmp/build_2d8369a5/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardQeNNmvAGOAMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexdqiiwdyJY1Meta } from "/tmp/build_2d8369a5/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutmAXKv7r6lOMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productlEhhNNApFUMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventstPABfJyqY0Meta } from "/tmp/build_2d8369a5/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93qatjSgU9NEMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexrzFG6BExojMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93yLZQ4Sxq1qMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93eqVakh44O1Meta } from "/tmp/build_2d8369a5/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as index4quhkRoU9kMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93j2sj0LmY4OMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinpxhrgO7g7AMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/join.vue?macro=true";
import { default as logint7k4lpzr8AMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/login.vue?macro=true";
import { default as logoutNjnGB365zKMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93Ovlw040JrgMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93w9ROoLg4eBMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93pNQm6O0gAiMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoriteso9oYnaZ0AoMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studiosahZkyNRWvoMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinbDxjlZSabJMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_934IPPWs2IyNMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexpVqleNzjNUMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as index0RodY8ahqVMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as about40drchvsMFMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentFCvXjr7EdUMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventsgMyGNo6ZHJMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93k9w8bQMaV9Meta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplexeHPqfYwU2Meta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productshw92RSQnk8Meta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_934GVS92qL7JMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewwp4tebEvEuMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexKiiCI1Ru1xMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93ZcXwgL9tEPMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as index84TghxR3LZMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_932i9WoqpHdaMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexdwEMUHOpLsMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsSiH7r6ibRNMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordings43qbLa260MMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsi0CjzL0yBIMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_934bQxrZU0iFMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as index06DQR7zCa5Meta } from "/tmp/build_2d8369a5/pages/[studio_url]/product/index.vue?macro=true";
import { default as index72TJvQ1h5lMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesv5mlNnCJRfMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsLIpjc8CAtDMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93bYHCTiY0AlMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93RUaLFBkwxcMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetcMRw2psM0CMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/reset.vue?macro=true";
import { default as shop1hv1P3RaFQMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/shop.vue?macro=true";
import { default as signup29jjpbUqdWMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/signup.vue?macro=true";
import { default as livew2E9hwIlFDMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsEjwqZBq6CpMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93YFzErN0TDaMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactGX54ATQqzGMeta } from "/tmp/build_2d8369a5/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as full7Q0A7AazF7Meta } from "/tmp/build_2d8369a5/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93vd9pK4Fm3GMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93vd9pK4Fm3GMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93vd9pK4Fm3GMeta || {},
    alias: _91product_id_93vd9pK4Fm3GMeta?.alias || [],
    redirect: _91product_id_93vd9pK4Fm3GMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: about1l6Nzr5WQ7Meta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: about1l6Nzr5WQ7Meta?.path ?? "about",
    meta: about1l6Nzr5WQ7Meta || {},
    alias: about1l6Nzr5WQ7Meta?.alias || [],
    redirect: about1l6Nzr5WQ7Meta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsP3toUyZZVnMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsP3toUyZZVnMeta?.path ?? "events",
    meta: eventsP3toUyZZVnMeta || {},
    alias: eventsP3toUyZZVnMeta?.alias || [],
    redirect: eventsP3toUyZZVnMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93sDq7PciCwCMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93sDq7PciCwCMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93sDq7PciCwCMeta || {},
    alias: _91media_id_93sDq7PciCwCMeta?.alias || [],
    redirect: _91media_id_93sDq7PciCwCMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplesR9JXJ1OXnMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45samplesR9JXJ1OXnMeta?.path ?? "free-sample",
    meta: free_45samplesR9JXJ1OXnMeta || {},
    alias: free_45samplesR9JXJ1OXnMeta?.alias || [],
    redirect: free_45samplesR9JXJ1OXnMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productse5YmKhonlxMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productse5YmKhonlxMeta?.path ?? "included-products",
    meta: included_45productse5YmKhonlxMeta || {},
    alias: included_45productse5YmKhonlxMeta?.alias || [],
    redirect: included_45productse5YmKhonlxMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_938MdlQThONLMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_938MdlQThONLMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_938MdlQThONLMeta || {},
    alias: _91media_id_938MdlQThONLMeta?.alias || [],
    redirect: _91media_id_938MdlQThONLMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewDSRivCybRgMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewDSRivCybRgMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewDSRivCybRgMeta || {},
    alias: viewDSRivCybRgMeta?.alias || [],
    redirect: viewDSRivCybRgMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexExTgh979urMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexExTgh979urMeta?.path ?? "lessons",
    meta: indexExTgh979urMeta || {},
    alias: indexExTgh979urMeta?.alias || [],
    redirect: indexExTgh979urMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93KL9xLR62HXMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93KL9xLR62HXMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93KL9xLR62HXMeta || {},
    alias: _91media_id_93KL9xLR62HXMeta?.alias || [],
    redirect: _91media_id_93KL9xLR62HXMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexkru1t6V1mZMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexkru1t6V1mZMeta?.path ?? "playlists/:playlist_id()",
    meta: indexkru1t6V1mZMeta || {},
    alias: indexkru1t6V1mZMeta?.alias || [],
    redirect: indexkru1t6V1mZMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93KRFOhEBHioMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93KRFOhEBHioMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93KRFOhEBHioMeta || {},
    alias: _91media_id_93KRFOhEBHioMeta?.alias || [],
    redirect: _91media_id_93KRFOhEBHioMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexrrGefgZMYFMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexrrGefgZMYFMeta?.path ?? "playlists",
    meta: indexrrGefgZMYFMeta || {},
    alias: indexrrGefgZMYFMeta?.alias || [],
    redirect: indexrrGefgZMYFMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionszS59NDv40JMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionszS59NDv40JMeta?.path ?? "private-sessions",
    meta: private_45sessionszS59NDv40JMeta || {},
    alias: private_45sessionszS59NDv40JMeta?.alias || [],
    redirect: private_45sessionszS59NDv40JMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsQCyzQyZEnjMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingsQCyzQyZEnjMeta?.path ?? "recordings",
    meta: recordingsQCyzQyZEnjMeta || {},
    alias: recordingsQCyzQyZEnjMeta?.alias || [],
    redirect: recordingsQCyzQyZEnjMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviews50tjGKze5LMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviews50tjGKze5LMeta?.path ?? "reviews",
    meta: reviews50tjGKze5LMeta || {},
    alias: reviews50tjGKze5LMeta?.alias || [],
    redirect: reviews50tjGKze5LMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index6jkYAMHr53Meta?.name ?? "buy-product-product_id",
    path: index6jkYAMHr53Meta?.path ?? "/buy/product/:product_id()",
    meta: index6jkYAMHr53Meta || {},
    alias: index6jkYAMHr53Meta?.alias || [],
    redirect: index6jkYAMHr53Meta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmSgGg5TuYCrMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmSgGg5TuYCrMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmSgGg5TuYCrMeta || {},
    alias: confirmSgGg5TuYCrMeta?.alias || [],
    redirect: confirmSgGg5TuYCrMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmrIckoUXfWbMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmrIckoUXfWbMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmrIckoUXfWbMeta || {},
    alias: confirmrIckoUXfWbMeta?.alias || [],
    redirect: confirmrIckoUXfWbMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendar7Gnc0inVOaMeta?.name ?? "calendar",
    path: calendar7Gnc0inVOaMeta?.path ?? "/calendar",
    meta: calendar7Gnc0inVOaMeta || {},
    alias: calendar7Gnc0inVOaMeta?.alias || [],
    redirect: calendar7Gnc0inVOaMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatwwIArMtJuQMeta?.name ?? "chat",
    path: chatwwIArMtJuQMeta?.path ?? "/chat",
    meta: chatwwIArMtJuQMeta || {},
    alias: chatwwIArMtJuQMeta?.alias || [],
    redirect: chatwwIArMtJuQMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93XH9Vgeir6FMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93XH9Vgeir6FMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93XH9Vgeir6FMeta || {},
    alias: _91group_id_93XH9Vgeir6FMeta?.alias || [],
    redirect: _91group_id_93XH9Vgeir6FMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutM6P6ZygKgOMeta?.name ?? "community-groups-group_id-about",
    path: aboutM6P6ZygKgOMeta?.path ?? "about",
    meta: aboutM6P6ZygKgOMeta || {},
    alias: aboutM6P6ZygKgOMeta?.alias || [],
    redirect: aboutM6P6ZygKgOMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feed95sIyNEIv7Meta?.name ?? "community-groups-group_id-feed",
    path: feed95sIyNEIv7Meta?.path ?? "feed",
    meta: feed95sIyNEIv7Meta || {},
    alias: feed95sIyNEIv7Meta?.alias || [],
    redirect: feed95sIyNEIv7Meta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersgMifS8oKDtMeta?.name ?? "community-groups-group_id-members",
    path: membersgMifS8oKDtMeta?.path ?? "members",
    meta: membersgMifS8oKDtMeta || {},
    alias: membersgMifS8oKDtMeta?.alias || [],
    redirect: membersgMifS8oKDtMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45edithbSCi6jJtkMeta?.name ?? "community-profile-edit",
    path: community_45profile_45edithbSCi6jJtkMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45edithbSCi6jJtkMeta || {},
    alias: community_45profile_45edithbSCi6jJtkMeta?.alias || [],
    redirect: community_45profile_45edithbSCi6jJtkMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93gYqaybh5lrMeta?.name ?? "community-profile-id",
    path: _91id_93gYqaybh5lrMeta?.path ?? "/community-profile/:id()",
    meta: _91id_93gYqaybh5lrMeta || {},
    alias: _91id_93gYqaybh5lrMeta?.alias || [],
    redirect: _91id_93gYqaybh5lrMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityeQAUNir0myMeta?.name ?? "community",
    path: communityeQAUNir0myMeta?.path ?? "/community",
    meta: communityeQAUNir0myMeta || {},
    alias: communityeQAUNir0myMeta?.alias || [],
    redirect: communityeQAUNir0myMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93rwkJdlSeYHMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93rwkJdlSeYHMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93rwkJdlSeYHMeta || {},
    alias: _91uuid_93rwkJdlSeYHMeta?.alias || [],
    redirect: _91uuid_93rwkJdlSeYHMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93nuY9TOaTa5Meta?.name ?? "contracts-unique_id",
    path: _91unique_id_93nuY9TOaTa5Meta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93nuY9TOaTa5Meta || {},
    alias: _91unique_id_93nuY9TOaTa5Meta?.alias || [],
    redirect: _91unique_id_93nuY9TOaTa5Meta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardQeNNmvAGOAMeta?.name ?? "dashboard",
    path: dashboardQeNNmvAGOAMeta?.path ?? "/dashboard",
    meta: dashboardQeNNmvAGOAMeta || {},
    alias: dashboardQeNNmvAGOAMeta?.alias || [],
    redirect: dashboardQeNNmvAGOAMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexdqiiwdyJY1Meta?.name ?? "event-details-event_id",
    path: indexdqiiwdyJY1Meta?.path ?? "/event/details/:event_id()",
    meta: indexdqiiwdyJY1Meta || {},
    alias: indexdqiiwdyJY1Meta?.alias || [],
    redirect: indexdqiiwdyJY1Meta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutmAXKv7r6lOMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutmAXKv7r6lOMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutmAXKv7r6lOMeta || {},
    alias: checkoutmAXKv7r6lOMeta?.alias || [],
    redirect: checkoutmAXKv7r6lOMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productlEhhNNApFUMeta?.name ?? "event-details-event_id-select-product",
    path: select_45productlEhhNNApFUMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productlEhhNNApFUMeta || {},
    alias: select_45productlEhhNNApFUMeta?.alias || [],
    redirect: select_45productlEhhNNApFUMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventstPABfJyqY0Meta?.name ?? "events",
    path: eventstPABfJyqY0Meta?.path ?? "/events",
    meta: eventstPABfJyqY0Meta || {},
    alias: eventstPABfJyqY0Meta?.alias || [],
    redirect: eventstPABfJyqY0Meta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93qatjSgU9NEMeta?.name ?? "gifts-uuid",
    path: _91uuid_93qatjSgU9NEMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93qatjSgU9NEMeta || {},
    alias: _91uuid_93qatjSgU9NEMeta?.alias || [],
    redirect: _91uuid_93qatjSgU9NEMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexrzFG6BExojMeta?.name ?? "gifts",
    path: indexrzFG6BExojMeta?.path ?? "/gifts",
    meta: indexrzFG6BExojMeta || {},
    alias: indexrzFG6BExojMeta?.alias || [],
    redirect: indexrzFG6BExojMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93yLZQ4Sxq1qMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93yLZQ4Sxq1qMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93yLZQ4Sxq1qMeta || {},
    alias: _91invitation_id_93yLZQ4Sxq1qMeta?.alias || [],
    redirect: _91invitation_id_93yLZQ4Sxq1qMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93eqVakh44O1Meta?.name ?? "gifts-product-product_id",
    path: _91product_id_93eqVakh44O1Meta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93eqVakh44O1Meta || {},
    alias: _91product_id_93eqVakh44O1Meta?.alias || [],
    redirect: _91product_id_93eqVakh44O1Meta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: index4quhkRoU9kMeta?.name ?? "index",
    path: index4quhkRoU9kMeta?.path ?? "/",
    meta: index4quhkRoU9kMeta || {},
    alias: index4quhkRoU9kMeta?.alias || [],
    redirect: index4quhkRoU9kMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93j2sj0LmY4OMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93j2sj0LmY4OMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93j2sj0LmY4OMeta || {},
    alias: _91invitation_unique_id_93j2sj0LmY4OMeta?.alias || [],
    redirect: _91invitation_unique_id_93j2sj0LmY4OMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinpxhrgO7g7AMeta?.name ?? "join",
    path: joinpxhrgO7g7AMeta?.path ?? "/join",
    meta: joinpxhrgO7g7AMeta || {},
    alias: joinpxhrgO7g7AMeta?.alias || [],
    redirect: joinpxhrgO7g7AMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: logint7k4lpzr8AMeta?.name ?? "login",
    path: logint7k4lpzr8AMeta?.path ?? "/login",
    meta: logint7k4lpzr8AMeta || {},
    alias: logint7k4lpzr8AMeta?.alias || [],
    redirect: logint7k4lpzr8AMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutNjnGB365zKMeta?.name ?? "logout",
    path: logoutNjnGB365zKMeta?.path ?? "/logout",
    meta: logoutNjnGB365zKMeta || {},
    alias: logoutNjnGB365zKMeta?.alias || [],
    redirect: logoutNjnGB365zKMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93Ovlw040JrgMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93Ovlw040JrgMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93Ovlw040JrgMeta || {},
    alias: _91meeting_type_slug_93Ovlw040JrgMeta?.alias || [],
    redirect: _91meeting_type_slug_93Ovlw040JrgMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93w9ROoLg4eBMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93w9ROoLg4eBMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93w9ROoLg4eBMeta || {},
    alias: _91meeting_unique_id_93w9ROoLg4eBMeta?.alias || [],
    redirect: _91meeting_unique_id_93w9ROoLg4eBMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93pNQm6O0gAiMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93pNQm6O0gAiMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93pNQm6O0gAiMeta || {},
    alias: _91meeting_unique_id_93pNQm6O0gAiMeta?.alias || [],
    redirect: _91meeting_unique_id_93pNQm6O0gAiMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoriteso9oYnaZ0AoMeta?.name ?? "my-favorites",
    path: my_45favoriteso9oYnaZ0AoMeta?.path ?? "/my-favorites",
    meta: my_45favoriteso9oYnaZ0AoMeta || {},
    alias: my_45favoriteso9oYnaZ0AoMeta?.alias || [],
    redirect: my_45favoriteso9oYnaZ0AoMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studiosahZkyNRWvoMeta?.name ?? "my-studios",
    path: my_45studiosahZkyNRWvoMeta?.path ?? "/my-studios",
    meta: my_45studiosahZkyNRWvoMeta || {},
    alias: my_45studiosahZkyNRWvoMeta?.alias || [],
    redirect: my_45studiosahZkyNRWvoMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinbDxjlZSabJMeta?.name ?? "optin",
    path: optinbDxjlZSabJMeta?.path ?? "/optin",
    meta: optinbDxjlZSabJMeta || {},
    alias: optinbDxjlZSabJMeta?.alias || [],
    redirect: optinbDxjlZSabJMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_934IPPWs2IyNMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_934IPPWs2IyNMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_934IPPWs2IyNMeta || {},
    alias: _91episode_id_934IPPWs2IyNMeta?.alias || [],
    redirect: _91episode_id_934IPPWs2IyNMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexpVqleNzjNUMeta?.name ?? "podcasts-podcast_id",
    path: indexpVqleNzjNUMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexpVqleNzjNUMeta || {},
    alias: indexpVqleNzjNUMeta?.alias || [],
    redirect: indexpVqleNzjNUMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: index0RodY8ahqVMeta?.name ?? "podcasts",
    path: index0RodY8ahqVMeta?.path ?? "/podcasts",
    meta: index0RodY8ahqVMeta || {},
    alias: index0RodY8ahqVMeta?.alias || [],
    redirect: index0RodY8ahqVMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_934bQxrZU0iFMeta?.name ?? "product-product_id",
    path: _91product_id_934bQxrZU0iFMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_934bQxrZU0iFMeta || {},
    alias: _91product_id_934bQxrZU0iFMeta?.alias || [],
    redirect: _91product_id_934bQxrZU0iFMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: about40drchvsMFMeta?.name ?? "product-product_id-about",
    path: about40drchvsMFMeta?.path ?? "about",
    meta: about40drchvsMFMeta || {},
    alias: about40drchvsMFMeta?.alias || [],
    redirect: about40drchvsMFMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentFCvXjr7EdUMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentFCvXjr7EdUMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contentFCvXjr7EdUMeta || {},
    alias: digital_45download_45contentFCvXjr7EdUMeta?.alias || [],
    redirect: digital_45download_45contentFCvXjr7EdUMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventsgMyGNo6ZHJMeta?.name ?? "product-product_id-events",
    path: eventsgMyGNo6ZHJMeta?.path ?? "events",
    meta: eventsgMyGNo6ZHJMeta || {},
    alias: eventsgMyGNo6ZHJMeta?.alias || [],
    redirect: eventsgMyGNo6ZHJMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93k9w8bQMaV9Meta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93k9w8bQMaV9Meta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93k9w8bQMaV9Meta || {},
    alias: _91media_id_93k9w8bQMaV9Meta?.alias || [],
    redirect: _91media_id_93k9w8bQMaV9Meta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplexeHPqfYwU2Meta?.name ?? "product-product_id-free-sample",
    path: free_45samplexeHPqfYwU2Meta?.path ?? "free-sample",
    meta: free_45samplexeHPqfYwU2Meta || {},
    alias: free_45samplexeHPqfYwU2Meta?.alias || [],
    redirect: free_45samplexeHPqfYwU2Meta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productshw92RSQnk8Meta?.name ?? "product-product_id-included-products",
    path: included_45productshw92RSQnk8Meta?.path ?? "included-products",
    meta: included_45productshw92RSQnk8Meta || {},
    alias: included_45productshw92RSQnk8Meta?.alias || [],
    redirect: included_45productshw92RSQnk8Meta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_934GVS92qL7JMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_934GVS92qL7JMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_934GVS92qL7JMeta || {},
    alias: _91media_id_934GVS92qL7JMeta?.alias || [],
    redirect: _91media_id_934GVS92qL7JMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewwp4tebEvEuMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewwp4tebEvEuMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewwp4tebEvEuMeta || {},
    alias: viewwp4tebEvEuMeta?.alias || [],
    redirect: viewwp4tebEvEuMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexKiiCI1Ru1xMeta?.name ?? "product-product_id-lessons",
    path: indexKiiCI1Ru1xMeta?.path ?? "lessons",
    meta: indexKiiCI1Ru1xMeta || {},
    alias: indexKiiCI1Ru1xMeta?.alias || [],
    redirect: indexKiiCI1Ru1xMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93ZcXwgL9tEPMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93ZcXwgL9tEPMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93ZcXwgL9tEPMeta || {},
    alias: _91media_id_93ZcXwgL9tEPMeta?.alias || [],
    redirect: _91media_id_93ZcXwgL9tEPMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: index84TghxR3LZMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: index84TghxR3LZMeta?.path ?? "playlists/:playlist_id()",
    meta: index84TghxR3LZMeta || {},
    alias: index84TghxR3LZMeta?.alias || [],
    redirect: index84TghxR3LZMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_932i9WoqpHdaMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_932i9WoqpHdaMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_932i9WoqpHdaMeta || {},
    alias: _91media_id_932i9WoqpHdaMeta?.alias || [],
    redirect: _91media_id_932i9WoqpHdaMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexdwEMUHOpLsMeta?.name ?? "product-product_id-playlists",
    path: indexdwEMUHOpLsMeta?.path ?? "playlists",
    meta: indexdwEMUHOpLsMeta || {},
    alias: indexdwEMUHOpLsMeta?.alias || [],
    redirect: indexdwEMUHOpLsMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsSiH7r6ibRNMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsSiH7r6ibRNMeta?.path ?? "private-sessions",
    meta: private_45sessionsSiH7r6ibRNMeta || {},
    alias: private_45sessionsSiH7r6ibRNMeta?.alias || [],
    redirect: private_45sessionsSiH7r6ibRNMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordings43qbLa260MMeta?.name ?? "product-product_id-recordings",
    path: recordings43qbLa260MMeta?.path ?? "recordings",
    meta: recordings43qbLa260MMeta || {},
    alias: recordings43qbLa260MMeta?.alias || [],
    redirect: recordings43qbLa260MMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsi0CjzL0yBIMeta?.name ?? "product-product_id-reviews",
    path: reviewsi0CjzL0yBIMeta?.path ?? "reviews",
    meta: reviewsi0CjzL0yBIMeta || {},
    alias: reviewsi0CjzL0yBIMeta?.alias || [],
    redirect: reviewsi0CjzL0yBIMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index06DQR7zCa5Meta?.name ?? "product",
    path: index06DQR7zCa5Meta?.path ?? "/product",
    meta: index06DQR7zCa5Meta || {},
    alias: index06DQR7zCa5Meta?.alias || [],
    redirect: index06DQR7zCa5Meta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: index72TJvQ1h5lMeta?.name ?? "profile",
    path: index72TJvQ1h5lMeta?.path ?? "/profile",
    meta: index72TJvQ1h5lMeta || {},
    alias: index72TJvQ1h5lMeta?.alias || [],
    redirect: index72TJvQ1h5lMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesv5mlNnCJRfMeta?.name ?? "profile-purchases",
    path: purchasesv5mlNnCJRfMeta?.path ?? "/profile/purchases",
    meta: purchasesv5mlNnCJRfMeta || {},
    alias: purchasesv5mlNnCJRfMeta?.alias || [],
    redirect: purchasesv5mlNnCJRfMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsLIpjc8CAtDMeta?.name ?? "profile-redemptions",
    path: redemptionsLIpjc8CAtDMeta?.path ?? "/profile/redemptions",
    meta: redemptionsLIpjc8CAtDMeta || {},
    alias: redemptionsLIpjc8CAtDMeta?.alias || [],
    redirect: redemptionsLIpjc8CAtDMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93bYHCTiY0AlMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93bYHCTiY0AlMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93bYHCTiY0AlMeta || {},
    alias: _91quiz_id_93bYHCTiY0AlMeta?.alias || [],
    redirect: _91quiz_id_93bYHCTiY0AlMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93RUaLFBkwxcMeta?.name ?? "reset-password-uid-token",
    path: _91token_93RUaLFBkwxcMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93RUaLFBkwxcMeta || {},
    alias: _91token_93RUaLFBkwxcMeta?.alias || [],
    redirect: _91token_93RUaLFBkwxcMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetcMRw2psM0CMeta?.name ?? "reset",
    path: resetcMRw2psM0CMeta?.path ?? "/reset",
    meta: resetcMRw2psM0CMeta || {},
    alias: resetcMRw2psM0CMeta?.alias || [],
    redirect: resetcMRw2psM0CMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shop1hv1P3RaFQMeta?.name ?? "shop",
    path: shop1hv1P3RaFQMeta?.path ?? "/shop",
    meta: shop1hv1P3RaFQMeta || {},
    alias: shop1hv1P3RaFQMeta?.alias || [],
    redirect: shop1hv1P3RaFQMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signup29jjpbUqdWMeta?.name ?? "signup",
    path: signup29jjpbUqdWMeta?.path ?? "/signup",
    meta: signup29jjpbUqdWMeta || {},
    alias: signup29jjpbUqdWMeta?.alias || [],
    redirect: signup29jjpbUqdWMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: livew2E9hwIlFDMeta?.name ?? "streaming-event_id-live",
    path: livew2E9hwIlFDMeta?.path ?? "/streaming/:event_id()/live",
    meta: livew2E9hwIlFDMeta || {},
    alias: livew2E9hwIlFDMeta?.alias || [],
    redirect: livew2E9hwIlFDMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsEjwqZBq6CpMeta?.name ?? "tips",
    path: tipsEjwqZBq6CpMeta?.path ?? "/tips",
    meta: tipsEjwqZBq6CpMeta || {},
    alias: tipsEjwqZBq6CpMeta?.alias || [],
    redirect: tipsEjwqZBq6CpMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93YFzErN0TDaMeta?.name ?? "waiver-uuid",
    path: _91uuid_93YFzErN0TDaMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93YFzErN0TDaMeta || {},
    alias: _91uuid_93YFzErN0TDaMeta?.alias || [],
    redirect: _91uuid_93YFzErN0TDaMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactGX54ATQqzGMeta?.name ?? "widgets-calendars-compact",
    path: compactGX54ATQqzGMeta?.path ?? "/widgets/calendars/compact",
    meta: compactGX54ATQqzGMeta || {},
    alias: compactGX54ATQqzGMeta?.alias || [],
    redirect: compactGX54ATQqzGMeta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: full7Q0A7AazF7Meta?.name ?? "widgets-calendars-full",
    path: full7Q0A7AazF7Meta?.path ?? "/widgets/calendars/full",
    meta: full7Q0A7AazF7Meta || {},
    alias: full7Q0A7AazF7Meta?.alias || [],
    redirect: full7Q0A7AazF7Meta?.redirect,
    component: () => import("/tmp/build_2d8369a5/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]